export default [
  { title: 'Rheinfelden', value: '133219205FE', address: 'CLINIUS+ Zahnärzte\nHebelstraße 19a\n79618 Rheinfelden' }
]
